import { customer } from '@icabbi/api-gateway-client';
import { Authentication } from '@icabbi/vue-authentication';

const defaultState = {
  disputeQueryClient: null,
};

const getters = {
  // eslint-disable-next-line no-shadow
  disputeQueryClient: (state, getters, rootState, rootGetters) => ({ dispatch }) => {
    if (state.disputeQueryClient === null) {
      const authentication = Authentication({ dispatch, getters: rootGetters });
      const { authenticationFailureInterceptor, bearerTokenInterceptor } = authentication;
      const disputeQueryClient = new customer.DisputeQueryConnector({
        baseURL: process.env.VUE_APP_API_GATEWAY_URL,
        timeout: parseInt(process.env.VUE_APP_HTTP_REQUEST_TIMEOUT, 10),
      });
      disputeQueryClient.httpClient.interceptors.response.use(undefined, error => authenticationFailureInterceptor(error));
      disputeQueryClient.httpClient.interceptors.request.use(config => bearerTokenInterceptor(config));
      state.disputeQueryClient = disputeQueryClient;
    }
    return state.disputeQueryClient;
  },
};

const actions = {

  async downloadEvidence(context, disputeId) {
    try {
      const disputeQueryClient = context.getters.disputeQueryClient(context);

      const data = await disputeQueryClient.getEvidenceFile(
        { disputeId },
      );
      return data;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      context.dispatch(
        'globalMessages/addError',
        { message: 'dispute.downloadEvidenceError', code: error.code ? error.code : '' },
        { root: true },
      );
      return { errorCode: error.httpStatusCode ? error.httpStatusCode : '500' };
    }
  },

  async submitEvidence(context, { disputeId, comment, providerInstance }) {
    try {
      const disputeQueryClient = context.getters.disputeQueryClient(context);

      const data = await disputeQueryClient.updateDispute(
        { disputeId, comment, submit: true, providerInstance }
      );
      context.dispatch(
        'globalMessages/addSuccess',
        { message: 'dispute.evidenceSubmitted' },
        { root: true },
      );
      return data;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      context.dispatch(
        'globalMessages/addError',
        { message: 'dispute.submitEvidenceError', code: error.code ? error.code : '' },
        { root: true },
      );
      return { errorCode: error.httpStatusCode ? error.httpStatusCode : '500' };
    }
  },

  async listDisputes(context, {
    page, maxPerPage, sort, startDate, endDate, dateType, dynamicSearch,
  }) {
    try {
      const params = { sort, page, maxPerPage, dynamicSearch };

      if (dateType === 'disputeDate') {
        params.startDisputeDate = startDate;
        params.endDisputeDate = endDate;
      }

      if (dateType === 'payoutDate') {
        params.startPayoutDate = startDate;
        params.endPayoutDate = endDate;
      }

      if (dateType === 'respondByDate') {
        params.startEvidenceDueDate = startDate;
        params.endEvidenceDueDate = endDate;
      }

      if (dateType === 'transactionDate') {
        params.startDate = startDate;
        params.endDate = endDate;
      }

      const disputeQueryClient = context.getters.disputeQueryClient(context);
      const disputes = await disputeQueryClient.listDisputes(params);
      return disputes;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      context.dispatch(
        'globalMessages/addError',
        { message: 'dispute.getDisputesError', code: error.code ? error.code : '' },
        { root: true },
      );
      return { errorCode: error.httpStatusCode ? error.httpStatusCode : '500' };
    }
  },
};

const mutations = {};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  actions,
  mutations,
};
